import React from "react";
import { CheckMark } from "@tomocredit/common-fe/components";
import { BoostIcon } from "components/common";
import { Link } from "react-router-dom";
import { boostLookbackSelectionUrl } from "../consts";

export const MaximizeCredit = ({ linkedAccount }) => {
  return (
    <div className="grid bg-boost-primary-50 rounded py-6 px-6 sm:px-8 gap-y-4">
      <p className="text-lg font-bold">Maximize your credit and earn $20!</p>
      <div className="flex items-center">
        <CheckMark className="my-0" />
        <p className="line-through font-normal">Become a subscriber</p>
      </div>
      <div className="flex items-center">
        <CheckMark className="my-0" />
        <p className={`${linkedAccount ? "line-through" : ""} font-normal`}>
          Add your first account
        </p>
      </div>
      <Link to={{ pathname: boostLookbackSelectionUrl }}>
        <div className="flex items-center">
          <BoostIcon color="#7249F5" style={{ height: 24, width: 24 }} />
          <p className="ml-3 underline font-bold">Upgrade your membership</p>
        </div>
      </Link>
    </div>
  );
};
